module.exports = __webpack_public_path__ + "static/media/ru.0cacf46e.svg";